/**
 * Qty Stepper Component
 * − [qty] +   tap targets ≥ 44px, accessibility labels
 */

import { getCurrentLanguage } from '../../../i18n';

const LABELS: Record<string, { dec: string; inc: string }> = {
  th:  { dec: 'ลด', inc: 'เพิ่ม' },
  en:  { dec: 'Decrease', inc: 'Increase' },
  zh:  { dec: '减少', inc: '增加' },
  ru:  { dec: 'Уменьшить', inc: 'Увеличить' },
  ja:  { dec: '減らす', inc: '増やす' },
  ko:  { dec: '줄이기', inc: '늘리기' },
};

/**
 * Renders a − qty + stepper.
 * @param itemId  - used to construct window handler names
 * @param qty     - current quantity (> 0 to show stepper, 0 to show Add button)
 */
export function renderQtyStepper(itemId: string, qty: number): string {
  const lang = getCurrentLanguage();
  const lbl = LABELS[lang] || LABELS.en;
  const safeId = itemId.replace(/[^a-zA-Z0-9]/g, '_');

  if (qty === 0) {
    return `
      <button
        class="menu-add-btn"
        onclick="window.addToCart?.('${itemId}')"
        aria-label="${lbl.inc}"
        style="
          min-width:44px;min-height:44px;padding:0 14px;
          background:#00B900;color:#fff;border:none;border-radius:8px;
          font-size:18px;font-weight:700;cursor:pointer;
          touch-action:manipulation;transition:opacity 0.15s;
        "
      >+</button>
    `;
  }

  return `
    <div class="menu-stepper" style="
      display:flex;align-items:center;gap:2px;
      border:1.5px solid #00B900;border-radius:8px;overflow:hidden;
    ">
      <button
        onclick="window.decreaseCart?.('${itemId}')"
        aria-label="${lbl.dec}"
        style="min-width:44px;min-height:44px;background:#fff;border:none;
          color:#00B900;font-size:20px;font-weight:700;cursor:pointer;touch-action:manipulation;"
      >−</button>
      <span
        id="stepper-qty-${safeId}"
        style="min-width:28px;text-align:center;font-size:15px;font-weight:700;color:#1a1a1a;"
      >${qty}</span>
      <button
        onclick="window.addToCart?.('${itemId}')"
        aria-label="${lbl.inc}"
        style="min-width:44px;min-height:44px;background:#fff;border:none;
          color:#00B900;font-size:20px;font-weight:700;cursor:pointer;touch-action:manipulation;"
      >+</button>
    </div>
  `;
}

/** Update stepper qty display in-place */
export function updateStepperUI(itemId: string, qty: number): void {
  const safeId = itemId.replace(/[^a-zA-Z0-9]/g, '_');
  const el = document.getElementById(`stepper-qty-${safeId}`);
  if (el) el.textContent = String(qty);
}
